import { Route, Switch } from 'react-router-dom';
import { TicketListings } from '../containers/TicketListings';
import { TicketDetails } from '../containers/TicketDetails';
import { TicketCreationPanel } from './TicketCreationPanel';
import { ROUTES } from '../constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Routes() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: ROUTES.ticket,
        component: TicketDetails
      }), /*#__PURE__*/_jsx(Route, {
        component: TicketListings
      })]
    }), /*#__PURE__*/_jsx(Route, {
      path: ROUTES.new,
      component: TicketCreationPanel
    })]
  });
}